import { Expose } from '../serialization/class-transformer/decorators';
import { MetaDataRequest } from './meta-data-request';

export class MetaDataExternalRequest extends MetaDataRequest {

    @Expose()
    fullRootModelName: string;
}
